module.exports = __webpack_public_path__ + "img/8.ca55e9dc.png";